<script lang="ts">
  import type { Facility, FacilityValidation } from "../../helpers/types";
  import ErrorText from "../atoms/ErrorText.svelte";
  import LockedTextInput from "../atoms/LockedTextInput.svelte";
  import Text from "../atoms/Text.svelte";
  import TextInput from "../atoms/TextInput.svelte";

  interface Props {
    facility: Facility;
    facilityValidator: FacilityValidation | undefined;
    class?: string;
    hasPressedContinue?: boolean;
    children?: import("svelte").Snippet;
  }

  let {
    facility = $bindable(),
    facilityValidator = $bindable(),
    class: className,
    hasPressedContinue = $bindable(false),
    children,
  }: Props = $props();
</script>

<div class={className}>
  {#if (facilityValidator?.errors?.facilityId && facility?.facilityId && facility?.facilityId.toString().length >= 12) || (hasPressedContinue && !facility.facilityId)}
    <ErrorText>Ogiltigt anläggnings-ID (735999xxxxxxxxxxxx)</ErrorText>
  {:else}
    {@render children?.()}
  {/if}
  <Text>18 siffror, finns på din faktura från ditt elnätsföretag.</Text>
  <LockedTextInput
    {hasPressedContinue}
    required={!facility.powerOfAttorney}
    inputPadding="pl-17"
    error={(facilityValidator?.errors?.facilityId &&
      facility?.facilityId &&
      facility?.facilityId.toString().length >= 12) ||
      (hasPressedContinue && !facility.facilityId)}
    max={"19"}
    bind:value={facility.facilityId}
    lockedValue="735999"
  />
  <div class="mt-2">
    {#if (facilityValidator?.errors?.areaId && facility?.areaId && facility?.areaId.length >= 3) || (hasPressedContinue && !facility.areaId)}
      <ErrorText>Ogiltigt områdes-ID</ErrorText>
    {:else}
      <Text variant="primary">Områdes-ID</Text>
    {/if}
  </div>
  <Text>Tre bokstäver. Uppgiften finns på din faktura från ditt elnätsföretag.</Text>
  <TextInput
    {hasPressedContinue}
    required={!facility.powerOfAttorney}
    error={(facilityValidator?.errors?.areaId &&
      facility?.areaId &&
      facility?.areaId.length >= 3) ||
      (hasPressedContinue && !facility.areaId)}
    max={"3"}
    bind:value={facility.areaId}
  />
</div>
